import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { setAnalyticTeamReportConfig } from '../../../../state/analytic/analyticTeamReportSlice';
import { backendClient } from '../../../../services/api/backend-client';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';

export function* fetchTeamReportConfigSaga(action) {
    try {
        const { teamId } = action.payload || {};

        if (!teamId) {
            throw new Error('Team ID is required');
        }
        
        const response = yield call(
            [backendClient, backendClient.get],
            `reports/team/${encodeURIComponent(teamId)}`
        );

        yield put(setAnalyticTeamReportConfig({
            teamId,
            config: response.data
        }));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to fetch analytic team report configurations', err?.message);
        yield put(showSnackbar({
            message: 'Failed to load report configurations',
            severity: 'error',
        }));
    }
}
